import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Datatable from ".././Common/Datatable";
import { getColumns, initialSort } from ".././Meetings/meetingsTableConfig";
import { MeetingType1, MeetingType2 } from '../../utils/types';
import { getUTCTimeZoneOffset } from '../../utils/utils';
import dayjs from 'dayjs';
import useGlobalContext from '../../context/useGlobalContext';

const generateRows = (meetings: any) =>
    meetings.map((item: any) => ({
        id: item.interactionId,
    title: item.interactionTitle,
    start_time: item.startTime,
    end_time: item.endTime,
    duration: item.duration,
    no_of_attendees: item.noOfAttendees,
    is_external: item.isExternal,
    attendees: item.attendees,
    organizer: item.empEmail,
    sentiment_score: item.sentimentScore,
    meeting_sentiment: item.overallSentiment,
    join_link: item.joinLink,
    role_in_interaction: item.roleInInteraction,
    response_status: item.responseStatus,
    profile_org_ids: item.profileOrgRelationshipIds,
    rating_source: item.ratingSource,
    clientDomains: item.clientDomains,
    }));

const GlobalSearchMeetingsView: React.FC<{ searchData: {  data: { meetings: any[] } } }> = ({ searchData }) => {
    const [columns] = useState<any[]>(getColumns());
    const [rows, setRows] = useState<any[]>([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [showSpinner] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const { calendar, startEndTime, timeRange } = useGlobalContext();
    const [search, setSearch] = useState<string>("");
    const [filters, setFilters] = useState<{
        date: { start_time: string; end_time: string } | undefined;
        is_external: undefined | boolean;
        group_type: string;
    }>({
        date: undefined,
        is_external: undefined,
        group_type: "",
    });
    const [sort, setSort] = useState(initialSort);
     console.log(search,filters);
    useEffect(() => {
        if (searchData) {
            let meetingList = searchData.data?.meetings || [];
            
            if (sort.sort_field) {
                meetingList = meetingList.sort((a: any, b: any) => {
                    const fieldA = a[sort.sort_field];
                    const fieldB = b[sort.sort_field];
                    if (sort.sort_order === "asc") {
                        return fieldA > fieldB ? 1 : -1;
                    }
                    return fieldA < fieldB ? 1 : -1;
                });
            }

            const startIdx = (pageNumber - 1) * pageSize;
            const paginatedMeetings = meetingList.slice(startIdx, startIdx + pageSize);
    
            setTotalRecord(meetingList.length);
            setRows(generateRows(paginatedMeetings));
        }
    }, [searchData, pageNumber, pageSize, sort]);
    


    const onPageChange = (value: number) => {
        setPageNumber(value);
    };

    const onPaginationChange = (pageNumber: number) => {
        onPageChange(pageNumber + 1);
    };

    const onSearch = (value: string) => {
        setSearch(value);
        setPageNumber(1);
    };

    const onGlobalFilterChange = (globalFilter: any) => {
        onSearch(globalFilter);
    };

    const onFilter = (value: any) => {
        setFilters(value);
        setPageNumber(1);
    };

    const onFilterChange = (columnFilter: any[]) => {
        const filterSelections: {
            date: { start_time: string; end_time: string } | undefined;
            is_external: undefined | boolean;
            group_type: string;
        } = {
            date: undefined,
            is_external: undefined,
            group_type: "",
        };

        columnFilter.forEach((filter) => {
            if (filter.id === "start_time") {
                const utcTimeOffset = getUTCTimeZoneOffset();
                const formattedStartDate = `${dayjs(filter.value).format("YYYY-MM-DD")}T00:00:00${utcTimeOffset}`;
                const formattedEndDate = `${dayjs(filter.value).format("YYYY-MM-DD")}T23:59:59${utcTimeOffset}`;
                filterSelections.date = {
                    start_time: formattedStartDate,
                    end_time: formattedEndDate,
                };
            }
            if (filter.id === "meetingType1") {
                if (filter.value === MeetingType1.Internal)
                    filterSelections.is_external = false;
                if (filter.value === MeetingType1.External)
                    filterSelections.is_external = true;
            }
            if (filter.id === "meetingType2") {
                if (filter.value === MeetingType2.FocusTime)
                    filterSelections.group_type = "focus_time";
                if (filter.value === MeetingType2.OneToOne)
                    filterSelections.group_type = "one_to_one";
                if (filter.value === MeetingType2.Group)
                    filterSelections.group_type = "group";
            }
        });
        onFilter(filterSelections);
    };

    const onSortingChange = (sorting: any[]) => {
        if (sorting && sorting.length > 0)
            setSort({
                sort_field: sorting[0].id,
                sort_order: sorting[0].desc === true ? "desc" : "asc",
            });
    };
    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
      };

    return (
        <>
            <Box
                className="flex flex-col justify-start items-start w-full"
                sx={{ gap: "12px" }}
            >
                <Box className="w-full">
                    <Datatable
                        columns={columns}
                        rows={rows}
                        rowCount={totalRecord}
                        pageSize={pageSize}
                        initialSort={sort}
                        onPaginationChange={onPaginationChange}
                        onSortingChange={onSortingChange}
                        onFilterChange={onFilterChange}
                        onGlobalFilterChange={onGlobalFilterChange}
                        startEndTime={startEndTime}
                        timeRange={timeRange}
                        calendarId={calendar?.calendar_id}
                        onPageSizeChange={(newPageSize: number | null | undefined) => {
                            if (newPageSize !== null && newPageSize !== undefined) {
                              handlePageSizeChange(newPageSize);
                            }
                          }}
                        columnVisibility={{  actual_duration: false, sharedDate: false, abstractiveScore: false, shareIcon: false}}
                    />
                </Box>
                {showSpinner && <CircularProgress />}
            </Box>
        </>
    );
};

export default GlobalSearchMeetingsView;
